export default function FeatureButton(props: any) {
    const deleteSelectedUser = () => {
        props.onDelete();
    }

    const saveAll = () => {
        props.onSaveAll();
    }

    const save = () => {
        props.onSave();
    }

    return (
        <div className="member-choice">
            <button className="save" onClick={() => saveAll()}>
                전체 엑셀저장
            </button>
            <button className="save" onClick={() => save()}>
                선택항목 엑셀저장
            </button>
            <button className="delete" onClick={() => deleteSelectedUser()}>
                선택항목 일괄삭제
            </button>
        </div>
    )
}